var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrograms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 144,
    viewBox: "0 0 238 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.732422,
    width: 238,
    height: 143,
    rx: 8,
    fill: "#EFF3F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6535_1117485)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 64.7324,
    width: 42.6667,
    height: 16,
    fill: "#F9E6DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.667,
    y: 64.7324,
    width: 40,
    height: 16,
    fill: "#F5CFB6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.667,
    y: 64.7324,
    width: 14,
    height: 16,
    fill: "#F6BD96"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.667,
    y: 64.7324,
    width: 42.6667,
    height: 16,
    fill: "#F7AA75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.333,
    y: 64.7324,
    width: 32,
    height: 16,
    fill: "#F89755"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.333,
    y: 64.7324,
    width: 42.6667,
    height: 16,
    fill: "#E5660B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6535_1117485"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 64.7324,
    width: 214,
    height: 16,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrograms);
export default __webpack_public_path__ + "static/media/programs.1877e1ffdb80a4cf8c6bc1d74c05f892.svg";
export { ForwardRef as ReactComponent };